import { Component } from '@angular/core';
import { UserService } from '../_Services/user.service';

import { Router, ActivatedRoute } from '@angular/router';  

@Component({
  templateUrl: 'viewuser.component.html'
})
export class ViewuserComponent { 

  user = []; 
  group = [];
  
  constructor(private userService: UserService, private route:ActivatedRoute) { 
         
  }
  ngOnInit() {  
    var id = this.route.snapshot.params['id'];
    this.userService.viewUser(id).subscribe(result => {
          
          this.user = result.data.User; 
          this.group = result.data.Group;
          console.log(result.data.User.id);
      });  
  } 

}


// WEBPACK FOOTER //
// ./src/app/users/viewuser.component.ts